(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('cacheService', cacheService);

  function cacheService(
    localStorageService
  ) {
    'ngInject';

    const cache = {};

    const service = {
      get: get,
      set: set,
      remove: remove,
      removeByPrefix: removeByPrefix
    };

    return service;

    function get (key) {
      // should return the value or null if not found
      // first check in memory to see if value exists
      // if not, check in localStorage (could be persistent value)
      // once the value is found, check if exp is set
      // if not, return the value
      // if exp is set, check if current epoch timestamp is greater than exp
      // if it is, then set the value as null in cache and return null
      // if it is less than exp, return the value
      let valueObj;
      let persistentValue = false;
      const currentTimeStamp = (new Date()).valueOf();

      if (cache[key]) {
        valueObj = cache[key];
      } else if (localStorageService.get(key)) {
        valueObj = localStorageService.get(key);
        persistentValue = true;
      } else {
        valueObj = null;
      }

      if (!valueObj) {
        return null;
      } else if (valueObj.exp && valueObj.exp < currentTimeStamp) {
        if (persistentValue) {
          localStorageService.set(key, null);
        } else {
          cache[key] = null;
        }
        return null;
      } else {
        return valueObj.value;
      }
    }

    function set (key, value, options) {
      // should check the options
      // if persistence is true, save in localStorage
      // else save in memory
      // if expiration is provided, store exp with the value
      // always store value as an object
      // {
      //   value: <value>,
      //   exp: <epoch timestamp for expiration>
      // }

      if (value === null) {
        remove(key);
        return;
      }

      const valueObj = {
        value: value
      };

      const currentTimeStamp = (new Date()).valueOf();
      if (options && options.expireAfterSeconds) {
        valueObj.exp = currentTimeStamp + options.expireAfterSeconds*1000;
      }

      if (options && options.persistence) {
        // if choosing to store in localStorage, provide one
        localStorageService.set(key, valueObj);
      }

      cache[key] = valueObj;
    }

    function remove (key) {
      delete cache[key];
      localStorageService.remove(key);
    }

    function removeByPrefix(prefix) {
      Object.keys(cache).forEach(function (key) {
        if (key.startsWith(prefix)) {
          remove(key);
        }
      });
    }
  }
})();
